import { render, staticRenderFns } from "./vertical_main.vue?vue&type=template&id=4f1277bd&scoped=true&"
import script from "./vertical_main.vue?vue&type=script&lang=js&"
export * from "./vertical_main.vue?vue&type=script&lang=js&"
import style0 from "./vertical_main.vue?vue&type=style&index=0&id=4f1277bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1277bd",
  null
  
)

export default component.exports